import * as actionTypes from '../utilities/ActionType';

const initialState = {
    selectedAssessmentsList:[],
    selectedAssessments: [],
    formGuid: '00000000-0000-0000-0000-000000000000'
}

const selectedAssessments = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_ASSESSMENT:
            return {
                ...state, selectedAssessmentsList:action.data
            };
        case actionTypes.REMOVE_ALL_ASSESSMENTS:
            return {
                ...state,
                selectedAssessments: []
            };
        case actionTypes.ADD_ASSESSMENT:
            const newSelectedAssessments = state.selectedAssessments;
            newSelectedAssessments.push(action.assessmentObject);
            return {
                ...state,
                selectedAssessments: newSelectedAssessments
            };
        case actionTypes.SET_FORM_GUID:
            return {
                ...state,
                formGuid: action.formGuid
            };
        case actionTypes.CLEAR_FORM_GUID:
            return {
                ...state,
                formGuid: '00000000-0000-0000-0000-000000000000'
            };
        default:
            return state;
    }
};

export default selectedAssessments;